<template>
  <div class="wrapper">
    <div
      v-for="referral in referrals"
      :key="referral.refereeEmail"
      class="border-bottom px-4 py-4">
      <div class="d-flex justify-content-between align-items-center">
        <h6>
          {{ referral.refereeName ? referral.refereeName : referral.refereeEmail }}
        </h6>
        <p class="text-gray small-text">
          {{ formatReferralSource(referral.source) }}
        </p>
      </div>
      <div>
        <div class="mt-xs">
          <referral-progress-check :complete="referral.accountCreated">
            <template #detail>
              <div class="ms-xs">
                Account Created
              </div>
            </template>
          </referral-progress-check>
        </div>
        <div class="mt-xs">
          <referral-progress-check :complete="referral.joined">
            <template #detail>
              <div class="ms-xs">
                Joined
              </div>
            </template>
          </referral-progress-check>
        </div>
        <div class="mt-xs">
          <referral-progress-check :complete="referral.conversionAwarded">
            <template #detail>
              <div
                class="d-flex align-items-center ms-xs">
                Credit Applied
                <div
                  v-if="referral.conversionAwarded"
                  class="ms-md text-gray small-text">
                  {{ formatDate(referral.modified) }}
                </div>
              </div>
            </template>
          </referral-progress-check>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReferralProgressCheck from './ReferralProgressCheck'
import ReferralsMixin from '../global/mixins/ReferralsMixin'

export default {
  name: 'ReferralHistoryMobile',
  components: { ReferralProgressCheck },
  mixins: [ReferralsMixin],
  props: {
    referrals: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
  .wrapper {
    margin-left: -15px;
    margin-right: -15px;
    border-top: $default-border;
  }
</style>
